/**
 * Wire format shared by Expo (native) and Vue (web). Marker `__zb` is checked
 * on both sides so foreign postMessage / extension noise is silently ignored.
 */

export const BRIDGE_VERSION = 1 as const;

export type Envelope =
    | { __zb: typeof BRIDGE_VERSION; id: string; dir: 'req'; method: string; payload: unknown }
    | { __zb: typeof BRIDGE_VERSION; id: string; dir: 'res'; payload: unknown }
    | { __zb: typeof BRIDGE_VERSION; id: string; dir: 'err'; error: { message: string } };

export const parseEnvelope = (raw: string): Envelope | null => {
    let v: unknown;
    try {
        v = JSON.parse(raw);
    } catch {
        return null;
    }
    if (!v || typeof v !== 'object') return null;
    const o = v as Record<string, unknown>;
    if (o.__zb !== BRIDGE_VERSION) return null;
    if (typeof o.id !== 'string') return null;
    if (o.dir !== 'req' && o.dir !== 'res' && o.dir !== 'err') return null;
    return v as Envelope;
};

let _seq = 0;
export const nextRequestId = (): string =>
    `${Date.now().toString(36)}-${(++_seq).toString(36)}`;
